import React, { Component } from 'react';
import L from 'leaflet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Card } from 'antd';

import { crearMapa, coordenadesCentreCatalunyaPerMonitorizacioRadar } from '../commons/mapa';
import AvisInformacioAddicionalMonitoritzacioRadarLlegenda from './avisInformacioAddicionalMonitoritzacioRadarLlegenda';
import { convertirTextAMomentUTC } from '../../commons/gestioDates';
import { avisObtenirUltimaDataRadar, netejarUltimaDataRadar } from '../../actions/avis';
import noDataImage from '../../images/NoData.png';
import { maxNativeZoomCatalunya } from '../commons/mapa';

const nivellZoomMapaPerDefecte = 7;
const urlTilesRadar = 'https://s3-eu-west-1.amazonaws.com/static-m.meteo.cat/tiles/radar/{any}/{mes}/{dia}/{hora}/{minut}/{z}/000/000/{x}/000/000/{y}.png';

L.TileLayer.SMCRadar = L.TileLayer.extend({
    /**
     * S'adapta la URL a lageneració de tiles que fa mapcache
     */
    getTileUrl: function (tilePoint) {
        var data = {
            s: this._getSubdomain(tilePoint),
            x: tilePoint.x,
            y: tilePoint.y,
            z: this._getZoomForUrl()
        };

        if (this._map && !this._map.options.crs.infinite) {
            var invertedY = this._globalTileRange.max.y - tilePoint.y;
            if (this.options.tms) {
                data['y'] = invertedY;
            }
            data['-y'] = invertedY;
        }

        return L.Util.template(this._url, {
            z: (data.z).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false}),
            x: (data.x).toLocaleString('en-US', {minimumIntegerDigits: 3, useGrouping: false}),
            y: (data.y).toLocaleString('en-US', {minimumIntegerDigits: 3, useGrouping: false})
        }, this.options);
    }
});

L.TileLayer.smcRadar = function (url, options) {
    return new L.TileLayer.SMCRadar(url, options);
};

/**
 * Substitueix els valors any, mes, dia, hora, minut, segons dintre de la variable url.
 * @param {String} url
 * @param {String} ultimaDataRadaAsText
 */
const crearURLTilesRadar = (url, ultimaDataRadaAsText) => {
    if (!ultimaDataRadaAsText) return;

    let ultimadataradar = convertirTextAMomentUTC(ultimaDataRadaAsText);

    const any = ultimadataradar.format('YYYY');
    const mes = ultimadataradar.format('MM');
    const dia = ultimadataradar.format('DD');
    const hora = ultimadataradar.format('HH');
    const minut = ultimadataradar.format('mm');

    return url.replace(/{any}/g, any)
        .replace(/{mes}/g, mes)
        .replace(/{dia}/g, dia)
        .replace(/{hora}/g, hora)
        .replace(/{minut}/g, minut);
};

const crearCapaRadar = () => {
    const optionsradar = {
        tms: true,
        opacity: 0.8,
        maxNativeZoom: maxNativeZoomCatalunya,
        errorTileUrl: noDataImage
    };
    return L.TileLayer.smcRadar(null,optionsradar);
};

const intervalPeticioEnMinuts = 4;
const intervalPeticioEnMills = intervalPeticioEnMinuts * 1000 * 60;

class AvisInformacioAddicionalMonitoritzacioRadar extends Component {

    componentDidMount() {

        this.mapa = crearMapa(this.mapaMonitoritzacioRadar, nivellZoomMapaPerDefecte, coordenadesCentreCatalunyaPerMonitorizacioRadar);

        this.radarLayer = crearCapaRadar();

        this.intervalActualitzarData = setInterval(() =>
            this.props.avisObtenirUltimaDataRadar(), intervalPeticioEnMills
        );

        this.props.avisObtenirUltimaDataRadar();
    }

    shouldComponentUpdate(nextProps) {
        //Si la data de l'última tile es la mateixa no cal fer el render
        return (nextProps.dataUltimaTileGeneradaRadar !== this.props.dataUltimaTileGeneradaRadar);
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.dataUltimaTileGeneradaRadar) return;

        const data = nextProps.dataUltimaTileGeneradaRadar;

        const newURL = crearURLTilesRadar(urlTilesRadar, data);
        this.radarLayer.setUrl(newURL);

        if (!this.mapa.hasLayer(this.radarLayer)) {
            this.mapa.addLayer(this.radarLayer);
        }
    }

    componentWillUnmount() {
        const { netejarUltimaDataRadar } = this.props;
        netejarUltimaDataRadar();
        this.mapa.remove();
        clearInterval(this.intervalActualitzarData);
    }

    render() {
        const data = this.props.dataUltimaTileGeneradaRadar;

        let datasAsTextFormated = null;

        if (data) {
            const dataAsMoment = convertirTextAMomentUTC(data);
            datasAsTextFormated = dataAsMoment.format('DD-MM-YYYY HH:mm [UTC]');
        } else {
            datasAsTextFormated = 'Dades no disponibles';
        }

        return (
            <Card className='avis-informacio-addicional-monitoritzacio-card' bordered={false}>
                <div className='avis-informacio-addicional-monitoritzacio-radar' style={{border: 'none'}}>
                    <div className='avis-informacio-addicional-monitoritzacio-radar-mapa'
                        ref={ ref => this.mapaMonitoritzacioRadar = ref }>
                    </div>
                    <div className='avis-informacio-addicional-monitoritzacio-data'>
                        {datasAsTextFormated}
                    </div>
                    <AvisInformacioAddicionalMonitoritzacioRadarLlegenda />
                </div>
            </Card>
        );
    }
}

AvisInformacioAddicionalMonitoritzacioRadar.propTypes = {
    avisObtenirUltimaDataRadar: PropTypes.func,
    netejarUltimaDataRadar: PropTypes.func,
    dataUltimaTileGeneradaRadar: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
        dataUltimaTileGeneradaRadar: state.avis.visualitzacio.dataUltimaTileGeneradaRadar
    };
};

export default connect(mapStateToProps, { avisObtenirUltimaDataRadar, netejarUltimaDataRadar })(AvisInformacioAddicionalMonitoritzacioRadar);



// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicionalMonitoritzacioRadar.js